import { Inject, Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { LEGACY_API_BASE_URL } from "@api";

@Injectable()
export class ApiSelectSearchService {
    constructor(private _http: HttpClient, @Inject(LEGACY_API_BASE_URL) private _baseUrl?: string) {}

    fetch(url: string): Observable<any> {
        return new Observable((observer) => {
            const headers = new HttpHeaders({
                "Content-Type": "application/json",
            });

            const discrminator = "HealthProfessional";
            let method;

            const MaxInt32 = 2147483647;
            let body = {
                maxResultCount: MaxInt32,
                skipCount: 0,
                sorting: null,
            };
            let params = new HttpParams();
            if (discrminator === "HealthProfessional") {
                method = "POST";
            }

            return this._http.request(method, `${this._baseUrl}${url}`, { headers, params, body }).subscribe({
                next: (response: any) => {
                    let result: { items: any[] } = response.result;
                    observer.next(result.items);
                    observer.complete();
                },
                error: (error) => {
                    observer.error(error);
                },
            });
        });
    }
}
